import styled from 'styled-components';

import { StyledTextField } from '../text-fieldish/text-fieldish.styled';

export const StyledTextArea = styled(StyledTextField)`
  resize: vertical;

  min-height: var(--height-minus-border);
  overflow: auto;

  /* Resetting the line height set by the text input */
  font: ${(p) => p.theme.token('text-style-form-input')};
`;

export const TextAreaSizeReference = styled(StyledTextArea)`
  /* Some style to help in the calculation of ideal height */
  height: auto;
  overflow: hidden;

  /* Hiding the reference textarea */
  position: absolute;
  top: 0;
  opacity: 0;
  pointer-events: none;
`;
